import { inject, Injectable, NgZone, Type } from '@angular/core';
import { ModalService as ModalServiceDDS } from '@usitsdasdesign/dds-ng/modal';
import { first } from 'rxjs/operators';

// dds-ng declares ModalRef internally but doesn't export it, so derive the type instead.
type ModalRef = ReturnType<ModalServiceDDS['open']>;

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private modalRef: ModalRef | null = null;

  private readonly modalService = inject(ModalServiceDDS);
  private readonly ngZone = inject(NgZone);

  open<T>(
    component: Type<T>,
    inputs?: Record<string, unknown>,
    enableEscForClosing?: boolean,
    onCloseFn?: () => void,
  ) {
    if (this.modalRef) {
      this.closeAll();
    }

    this.modalRef = this.modalService.open(
      component,
      inputs,
      enableEscForClosing,
    );

    this.modalRef
      .onClosed()
      .pipe(first())
      .subscribe(() => {
        this.ngZone.run(() => {
          onCloseFn?.();
        });
        this.modalRef = null;
      });

    return this.modalRef;
  }

  close(data?: unknown): void {
    this.modalService.close(data);
    this.modalRef = null;
  }

  closeAll(): void {
    this.modalService.closeAll();
  }
}
